import { useEffect } from "react"

export default function () {
    useEffect(() => {
        const seeMore = document.getElementById('see-more')
        if (!seeMore) return

        let scrollTimer: ReturnType<typeof setTimeout> | undefined
        const handleClick = () => {
            const description = document.getElementById('description')
            if (!description) return
            scrollTimer = setTimeout(() => {
                description.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }, 120)
        }

        seeMore.addEventListener('click', handleClick)
        return () => {
            seeMore.removeEventListener('click', handleClick)
            if (scrollTimer) clearTimeout(scrollTimer)
        }
    }, [])

    return null
}
